import React from 'react'
import { pxToRem, COLOR } from 'theme'
import { Dialog } from 'components/Dialog'
import Button from 'components/Button'
import Card from 'components/Card'
import { Box } from 'components/Layout'
import { Text } from 'components/Typography'
import { useAuth, UserRole } from '@modmd/data'

const WARNING_MESSAGE = (hasPermission: boolean) =>
  hasPermission
    ? "This session can't be closed, would you like to delete it? Att. this is not reversible"
    : "This session can't be closed"

interface Props {
  isOpen?: boolean
  onDismiss: () => void
  onFinish: () => void
  isDeleteTestSessionLoading?: boolean
}

export const DeleteTestSessionDialog: React.VFC<Props> = ({
  isOpen,
  onDismiss,
  onFinish,
  isDeleteTestSessionLoading,
}) => {
  const auth = useAuth()
  const hasPermission = auth.hasRoles([UserRole.ADMIN, UserRole.SUPER_ADMIN])

  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss} maxWidth={pxToRem(512)}>
      <Card>
        <Card.Title onDismiss={onDismiss}>
          {hasPermission ? 'Delete testing session' : 'Testing session'}
        </Card.Title>
        <Card.Content display="grid" gridGap="0.5rem">
          <Text color={COLOR.brand}>{WARNING_MESSAGE(hasPermission)}</Text>
          {hasPermission && (
            <Box display="flex" justifyContent="space-between" mt="1rem">
              <Button colorVariant="secondary" onClick={onDismiss}>
                Cancel
              </Button>
              <Button
                isFetching={isDeleteTestSessionLoading}
                colorVariant="primary"
                onClick={onFinish}
              >
                Delete TestSession
              </Button>
            </Box>
          )}
          {!hasPermission && (
            <Box display="flex" justifyContent="center" mt="1rem">
              <Button colorVariant="secondary" onClick={onDismiss}>
                I agree
              </Button>
            </Box>
          )}
        </Card.Content>
      </Card>
    </Dialog>
  )
}
